"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MousePosition = void 0;
var MousePosition_1 = require("ol/control/MousePosition");
var MousePosition = /** @class */ (function () {
    /**
    * _displayProjection - defaults to the map display projection
    * */
    function MousePosition(_map, _textPack, _displayProjection) {
        if (_displayProjection === void 0) { _displayProjection = null; }
        var _this = this;
        this._map = _map;
        this._textPack = _textPack;
        this._displayProjection = _displayProjection;
        this._initialised = false;
        this.init = function () {
            if (!_this._initialised) {
                if (_this._displayProjection === null) {
                    _this._displayProjection = _this._map.options.dataProjection;
                }
                _this.initMousePosition();
                _this._initialised = true;
            }
        };
        this.initMousePosition = function () {
            var self = _this;
            if (!('ontouchstart' in window && navigator.maxTouchPoints > 0)) {
                var mousePositionControl = new MousePosition_1.default({
                    coordinateFormat: function (coordinate) {
                        return coordinate[0].toFixed(0) + " " + coordinate[1].toFixed(0);
                    },
                    projection: _this._displayProjection,
                    className: 'custom-mouse-position',
                    target: document.getElementById('mouse-position'),
                    undefinedHTML: _this._textPack.mousePosition
                });
                _this._map.olMap.addControl(mousePositionControl);
            }
            else {
                //mobile / touch - hide mouse position
                $("#mouse-position").hide();
            }
        };
        this.init();
    }
    return MousePosition;
}());
exports.MousePosition = MousePosition;
//# sourceMappingURL=MousePosition.js.map